import axios from "../config/axios-neo4j"


export const GraphRepository = {
  // Get all node labels
  getAllNodeLabels: () => {
    return axios.get('/kb/graph/nodes');
  },

  // Get all relationship types
  getAllRelationshipTypes: () => {
    return axios.get('/kb/graph/relationships');
  },

  // Get all relationship types
  getRdfTriples: (visibleNodes, signal) => {
    return axios.get('/kb/graph/rdf/triples', {
      params: {node_types: visibleNodes},
      paramsSerializer: {
        indexes: null, // Use repeat style: ?node_types=a&node_types=b instead of ?node_types[0]=a&node_types[1]=b
      },
      signal
    });
  },

  // Get complete graph schema
  getGraphSchema: () => {
    return axios.get('/kb/graph/schema');
  },

  // Get node properties by label
  getNodeProperties: (label) => {
    return axios.get(`/kb/graph/node/${label}/properties`);
  },

  // Get node count by label
  getNodeCount: (label) => {
    return axios.get(`/kb/graph/node/${label}/count`);
  },

  // Get node count by label
  getNodesForLabel: (label) => {
    return axios.get(`/kb/graph/node/${label}/all`);
  },

  // Get node count by label
  getNodeById: (label, id) => {
    return axios.get(`/kb/graph/node/${label}/${id}`);
  },

  // Get node count by label
  deleteNode: (label, id) => {
    return axios.delete(`/kb/graph/node/${label}/${id}`);
  },

  // Get node count by label
  toggleActive: (label, id) => {
    return axios.put(`/kb/graph/node/${label}/${id}/toggle-active`);
  },

  // Get relationship properties by type
  getRelationshipProperties: (type) => {
    return axios.get(`/kb/graph/relationship/${type}/properties`);
  },

  // Get relationship properties by type
  executeScript: (query) => {
    return axios.post(`/kb/graph/execute`, {query});
  },

  // Create a new node
  createNode: (label, properties) => {
    return axios.post('/kb/graph/node', {
      label,
      properties
    });
  },
  // Update a new node
  updateNode: (label, id, properties) => {
    return axios.put(`/kb/graph/node/${label}/${id}`, {
      label,
      properties
    });
  },

  // Create a new relationship
  createRelationship: (fromLabel, fromId, toLabel, toId, relationshipType, properties = {}) => {
    return axios.post('/kb/graph/relationship', {
      from_label: fromLabel,
      from_id: fromId,
      to_label: toLabel,
      to_id: toId,
      relationship_type: relationshipType,
      properties
    });
  }
}